
import React, { useCallback } from 'react';
import reloadImg from '../assets/images/homepage/reload.svg';
// import { checkAllotted, checkNotAllotted } from '../../../config/utils';

const AllotmentComponent = ({ data, className, checkStatus, isLoading }) => {
  
  const handleReload = (eve) => {
    if (!isLoading) {
      checkStatus(eve, data?.pan_number);
    }
  };


  const checkNotAllottedd = (data) => {

    if (
      data?.allotment_status === "Allotted" &&
      data?.allotted !== "0" &&
      data?.applied !== "0"
    ) {
      return <span className="text-[#04AA6D]">({data?.allotted} / {data?.applied})</span>;
    } else if (data?.allotment_status == "Not Allotted") {
      return <span className="text-[#FF0000]">({data?.allotted} / {data?.applied})</span>;
    } else {
    return null; // Avoid returning an empty stringa
    }
  };

  const loginData = localStorage.getItem('login')
  ? JSON.parse(localStorage.getItem('login'))
  : ''

  return (
    <div className={className}>
      <div className="checkAllloemntPart_box_shadow p-5 border_radius border border-[#e5e5e5]">
        <div className="flex flex-wrap justify-between gap-3">
          <div className="flex items-center">
            <div>
              <div className="allotment_logo_section flex items-center justify-center me-3 md:me-5">
                <p className="allotment_logo_text">{(data?.pan_number)?.slice(0, 1)}</p>
              </div>
            </div>
            <div>
              <h3 className="allotment_name md:pb-2 text-[#58585a]">{data?.full_name || '+'+loginData?.country_code+' '+loginData?.mobile_number }</h3>
              <p className='pe-2'>{data?.pan_number}</p>
            </div>
          </div>
          {data?.is_allotment &&
            <div className="flex items-center">
              <p className="pe-3 md:pe-5  max-w-[130px]">
                {checkNotAllottedd(data)} {data?.allotment_status}
              </p>
              <button
                className={`reload_btn flex items-center justify-center cursor-pointer  ${isLoading ? 'opacity-50 cursor-not-allowed' : ''
                  }`}
                onClick={handleReload}
                disabled={isLoading}
              >
                {isLoading ? (
                  <img
                    src={reloadImg}
                    alt="reload"
                    width={22}
                    height={22}
                    className="animate-spin"
                  />
                ) : (
                  <img src={reloadImg} alt="reload" width={22} height={22} />
                )}
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default React.memo(AllotmentComponent);
